<ion-item class="item-0" lines="none" [style.marginLeft.px]="marginLeft">
  <ion-icon [src]="icon | getImagePipe" class="ft-16 ion-align-self-start"></ion-icon>
  <div class="flex flex-col">
    <ion-text class="lbl-med-16 ml-8" *ngIf="lable1">{{isTranslate ? (lable1 | getLanguagePipe) : lable1}}</ion-text>
    <ion-text class="lbl-12  ml-8" *ngIf="lable2">{{isTranslatelbl2 ? (lable2 | getLanguagePipe) : lable2}}</ion-text>
  </div>
  </ion-item>